import OrderCostSummaryV3 from "../OrderCostSummaryV3";

const OrderCostSummaryV4 = OrderCostSummaryV3;

export default OrderCostSummaryV4;
